"use client";
import InputDataContent from "@/components/inquiryDetails/inputDataContent";
import ResultContent from "@/components/resultContent";
import { FlexCol } from "@/components/ui";

const companyInfoInput = [{ label: "شماره شناسایی", value: "10100200001" }];

const companyInfoResult = [
  { label: "نام شرکت", value: "شرکت نمونه صنعت پارس" },
  { label: "شناسه ملی", value: "10100200001" },
  { label: "شماره ثبت", value: "12345" },
  { label: "کد پستی", value: "1234567890" },
  { label: "تاریخ ثبت", value: "1385/06/20" },
  { label: "شهر", value: "تهران" },
  { label: "استان", value: "تهران" },
  { label: "وضعیت", value: "فعال" },
  { label: "سرمایه کل", value: "۱٬۰۰۰٬۰۰۰٬۰۰۰ ریال" },
  { label: "نوع شرکت", value: "سهامی خاص" },
  { label: "اداره ثبت", value: "اداره ثبت شرکت‌های تهران" },
  { label: "نشانی", value: "تهران، خیابان ولیعصر، پلاک ۱۲۳" },
  { label: "صاحبان امضا", value: "مدیرعامل به تنهایی" },
  { label: "موضوع فعالیت", value: "تولید و توزیع قطعات صنعتی" },
];

const CompanyInfoSample = () => (
  <FlexCol className="items-stretch">
    <div className="mb-5 flex items-center justify-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-700">
      <span>⚠️</span>
      <span>این نتیجه صرفاً یک نمونه است و اطلاعات واقعی نیست</span>
    </div>
    <InputDataContent content={companyInfoInput} />
    <ResultContent content={companyInfoResult} />
  </FlexCol>
);

export default CompanyInfoSample;
